import { createContext, useContext, useState } from 'react'

const PWAInstallContext = createContext(null)

export function PWAInstallProvider({ children }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  return (
    <PWAInstallContext.Provider value={{ deferredPrompt, setDeferredPrompt }}>
      {children}
    </PWAInstallContext.Provider>
  )
}

export function usePWAInstall() {
  return useContext(PWAInstallContext)
}
